import React, { Component } from "react";
import { withScope, captureException } from "@sentry/react";

export function ErrorLogger(ComponentToWrap) {
    return class WrappedComponent extends Component {
        state = {
            isError: false
        };

        logError = (error, errorInfo = null) => {
            withScope(scope => {
                scope.setLevel("fatal");
                captureException(error, { extra: errorInfo });
            });
        };

        isChromeScriptError = e => (e.message || "").includes("Script error");

        errorEventHandler = error => {
            if (!this.isChromeScriptError(error)) {
                this.setState({ isError: true });
                this.logError(error);
            }
        };

        clearError = () => {
            this.setState({ isError: false });
        };

        componentDidMount() {
            window.addEventListener("error", this.errorEventHandler);
        }

        componentWillUnmount() {
            window.removeEventListener("error", this.errorEventHandler);
        }

        componentDidCatch(error, errorInfo) {
            this.setState({ isError: true });
            this.logError(error, errorInfo);
        }

        render() {
            return (
                <ComponentToWrap
                    {...this.props}
                    isError={this.state.isError}
                    clearError={this.clearError}
                />
            );
        }
    };
}
